import { render, staticRenderFns } from "./BioPage.vue?vue&type=template&id=61962e8e&scoped=true&"
import script from "./BioPage.vue?vue&type=script&lang=js&"
export * from "./BioPage.vue?vue&type=script&lang=js&"
import style0 from "./BioPage.vue?vue&type=style&index=0&id=61962e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61962e8e",
  null
  
)

export default component.exports